import { useViewCurrentUserProfileQuery } from '@/api/profile';

export const useProfile = () => {
  const { data: profile, isLoading } = useViewCurrentUserProfileQuery();
  return {
    ...profile,
    isLoadingProfile: isLoading,
  };
};
